/* eslint-disable no-unused-vars */
/* eslint-disable no-redeclare */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-undef */
!(function (t, n) {
  'object' == typeof exports && 'object' == typeof module
    ? (module.exports = n())
    : 'function' == typeof define && define.amd
    ? define([], n)
    : 'object' == typeof exports
    ? (exports.wxcry = n())
    : (t.wxcry = n());
})('undefined' != typeof self ? self : this, function () {
  return (function (t) {
    function n(r) {
      if (e[r]) return e[r].exports;
      var i = (e[r] = {
        i: r,
        l: !1,
        exports: {},
      });
      return t[r].call(i.exports, i, i.exports, n), (i.l = !0), i.exports;
    }
    var e = {};
    return (
      (n.m = t),
      (n.c = e),
      (n.d = function (t, e, r) {
        n.o(t, e) ||
          Object.defineProperty(t, e, {
            configurable: !1,
            enumerable: !0,
            get: r,
          });
      }),
      (n.n = function (t) {
        var e =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return n.d(e, 'a', e), e;
      }),
      (n.o = function (t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
      }),
      (n.p = ''),
      n((n.s = 1))
    );
  })([
    function (t, n, e) {
      !(function (e, r) {
        t.exports = n = r();
      })(0, function () {
        var t =
          t ||
          (function (t, n) {
            var e =
                Object.create ||
                (function () {
                  function t() {}
                  return function (n) {
                    var e;
                    return (t.prototype = n), (e = new t()), (t.prototype = null), e;
                  };
                })(),
              r = {},
              i = (r.lib = {}),
              o = (i.Base = (function () {
                return {
                  extend: function (t) {
                    var n = e(this);
                    return (
                      t && n.mixIn(t),
                      (n.hasOwnProperty('init') && this.init !== n.init) ||
                        (n.init = function () {
                          n.$super.init.apply(this, arguments);
                        }),
                      (n.init.prototype = n),
                      (n.$super = this),
                      n
                    );
                  },
                  create: function () {
                    var t = this.extend();
                    return t.init.apply(t, arguments), t;
                  },
                  init: function () {},
                  mixIn: function (t) {
                    for (var n in t) t.hasOwnProperty(n) && (this[n] = t[n]);
                    t.hasOwnProperty('toString') && (this.toString = t.toString);
                  },
                  clone: function () {
                    return this.init.prototype.extend(this);
                  },
                };
              })()),
              s = (i.WordArray = o.extend({
                init: function (t, n) {
                  (t = this.words = t || []), (this.sigBytes = void 0 != n ? n : 4 * t.length);
                },
                toString: function (t) {
                  return (t || u).stringify(this);
                },
                concat: function (t) {
                  var n = this.words,
                    e = t.words,
                    r = this.sigBytes,
                    i = t.sigBytes;
                  if ((this.clamp(), r % 4))
                    for (var o = 0; o < i; o++) {
                      var s = (e[o >>> 2] >>> (24 - (o % 4) * 8)) & 255;
                      n[(r + o) >>> 2] |= s << (24 - ((r + o) % 4) * 8);
                    }
                  else for (var o = 0; o < i; o += 4) n[(r + o) >>> 2] = e[o >>> 2];
                  return (this.sigBytes += i), this;
                },
                clamp: function () {
                  var n = this.words,
                    e = this.sigBytes;
                  (n[e >>> 2] &= 4294967295 << (32 - (e % 4) * 8)), (n.length = t.ceil(e / 4));
                },
                clone: function () {
                  var t = o.clone.call(this);
                  return (t.words = this.words.slice(0)), t;
                },
                random: function (n) {
                  for (var e, r = [], i = 0; i < n; i += 4) {
                    var o = (function (n) {
                      var n = n,
                        e = 987654321,
                        r = 4294967295;
                      return function () {
                        (e = (36969 * (65535 & e) + (e >> 16)) & r),
                          (n = (18e3 * (65535 & n) + (n >> 16)) & r);
                        var i = ((e << 16) + n) & r;
                        return (i /= 4294967296), (i += 0.5) * (t.random() > 0.5 ? 1 : -1);
                      };
                    })(4294967296 * (e || t.random()));
                    (e = 987654071 * o()), r.push((4294967296 * o()) | 0);
                  }
                  return new s.init(r, n);
                },
              })),
              a = (r.enc = {}),
              u = (a.Hex = {
                stringify: function (t) {
                  for (var n = t.words, e = t.sigBytes, r = [], i = 0; i < e; i++) {
                    var o = (n[i >>> 2] >>> (24 - (i % 4) * 8)) & 255;
                    r.push((o >>> 4).toString(16)), r.push((15 & o).toString(16));
                  }
                  return r.join('');
                },
                parse: function (t) {
                  for (var n = t.length, e = [], r = 0; r < n; r += 2)
                    e[r >>> 3] |= parseInt(t.substr(r, 2), 16) << (24 - (r % 8) * 4);
                  return new s.init(e, n / 2);
                },
              }),
              c = (a.Latin1 = {
                stringify: function (t) {
                  for (var n = t.words, e = t.sigBytes, r = [], i = 0; i < e; i++) {
                    var o = (n[i >>> 2] >>> (24 - (i % 4) * 8)) & 255;
                    r.push(String.fromCharCode(o));
                  }
                  return r.join('');
                },
                parse: function (t) {
                  for (var n = t.length, e = [], r = 0; r < n; r++)
                    e[r >>> 2] |= (255 & t.charCodeAt(r)) << (24 - (r % 4) * 8);
                  return new s.init(e, n);
                },
              }),
              f = (a.Utf8 = {
                stringify: function (t) {
                  try {
                    return decodeURIComponent(escape(c.stringify(t)));
                  } catch (t) {
                    throw new Error('Malformed UTF-8 data');
                  }
                },
                parse: function (t) {
                  return c.parse(unescape(encodeURIComponent(t)));
                },
              }),
              h = (i.BufferedBlockAlgorithm = o.extend({
                reset: function () {
                  (this._data = new s.init()), (this._nDataBytes = 0);
                },
                _append: function (t) {
                  'string' == typeof t && (t = f.parse(t)),
                    this._data.concat(t),
                    (this._nDataBytes += t.sigBytes);
                },
                _process: function (n) {
                  var e = this._data,
                    r = e.words,
                    i = e.sigBytes,
                    o = this.blockSize,
                    a = 4 * o,
                    u = i / a;
                  u = n ? t.ceil(u) : t.max((0 | u) - this._minBufferSize, 0);
                  var c = u * o,
                    f = t.min(4 * c, i);
                  if (c) {
                    for (var h = 0; h < c; h += o) this._doProcessBlock(r, h);
                    var l = r.splice(0, c);
                    e.sigBytes -= f;
                  }
                  return new s.init(l, f);
                },
                clone: function () {
                  var t = o.clone.call(this);
                  return (t._data = this._data.clone()), t;
                },
                _minBufferSize: 0,
              })),
              l =
                ((i.Hasher = h.extend({
                  cfg: o.extend(),
                  init: function (t) {
                    (this.cfg = this.cfg.extend(t)), this.reset();
                  },
                  reset: function () {
                    h.reset.call(this), this._doReset();
                  },
                  update: function (t) {
                    return this._append(t), this._process(), this;
                  },
                  finalize: function (t) {
                    return t && this._append(t), this._doFinalize();
                  },
                  blockSize: 16,
                  _createHelper: function (t) {
                    return function (n, e) {
                      return new t.init(e).finalize(n);
                    };
                  },
                  _createHmacHelper: function (t) {
                    return function (n, e) {
                      return new l.HMAC.init(t, e).finalize(n);
                    };
                  },
                })),
                (r.algo = {}));
            return r;
          })(Math);
        return t;
      });
    },
    function (t, n, e) {
      'use strict';

      function r(t) {
        return t && t.__esModule
          ? t
          : {
              default: t,
            };
      }
      Object.defineProperty(n, '__esModule', {
        value: !0,
      });
      var i = e(2),
        o = r(i),
        s = e(3),
        a = r(s),
        u = {
          generateSign: function (t, platform) {
            var skey =
              platform == '51jobWX'
                ? 'b5650e675758805d28e95b6f39fea667'
                : 'jmhbz4xv1p8tw9z6umt6cw93bri96iuo';
            return (0, a.default)(
              (0, o.default)(JSON.stringify(t) + u.nowDate() + skey).toString(),
            ).toString();
          },
          generateSignResource: function (t, platform) {
            var skey =
              platform == '51jobWX'
                ? 'b5650e675758805d28e95b6f39fea667'
                : 'jmhbz4xv1p8tw9z6umt6cw93bri96iuo';
            return (0, a.default)((0, o.default)(t + u.nowDate() + skey).toString()).toString();
          },
          nowDate: function () {
            var d = new Date();
            //得到1970年一月一日到现在的秒数
            var len = d.getTime();
            //本地时间与GMT时间的时间偏移差(注意：GMT这是UTC的民间名称。GMT=UTC）
            var offset = d.getTimezoneOffset() * 60000;
            //得到现在的格林尼治时间
            var utcTime = len + offset;
            var t = new Date(utcTime + 3600000 * 8);
            return (
              t.getFullYear().toString() +
              (t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1).toString() +
              (t.getDate() < 10 ? '0' + t.getDate() : t.getDate()).toString() +
              t.getHours().toString()
            );
          },
          generateMapSign: function () {
            var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            t = u.objKeySort(t);
            var n = '';
            for (var e in t) n += t[e];
            return (0, a.default)(n + 'D(*(@$@Uhshd97192eH$').toString();
          },
          objKeySort: function (t) {
            for (var n = Object.keys(t).sort(), e = {}, r = 0; r < n.length; r++) e[n[r]] = t[n[r]];
            return e;
          },
        };
      n.default = u;
    },
    function (t, n, e) {
      !(function (r, i) {
        t.exports = n = i(e(0));
      })(0, function (t) {
        return (
          (function (n) {
            var e = t,
              r = e.lib,
              i = r.WordArray,
              o = r.Hasher,
              s = e.algo,
              a = [],
              u = [];
            !(function () {
              function t(t) {
                return (4294967296 * (t - (0 | t))) | 0;
              }
              for (var e = 2, r = 0; r < 64; )
                (function (t) {
                  for (var e = n.sqrt(t), r = 2; r <= e; r++) if (!(t % r)) return !1;
                  return !0;
                })(e) && (r < 8 && (a[r] = t(n.pow(e, 0.5))), (u[r] = t(n.pow(e, 1 / 3))), r++),
                  e++;
            })();
            var c = [],
              f = (s.SHA256 = o.extend({
                _doReset: function () {
                  this._hash = new i.init(a.slice(0));
                },
                _doProcessBlock: function (t, n) {
                  for (
                    var e = this._hash.words,
                      r = e[0],
                      i = e[1],
                      o = e[2],
                      s = e[3],
                      a = e[4],
                      f = e[5],
                      h = e[6],
                      l = e[7],
                      d = 0;
                    d < 64;
                    d++
                  ) {
                    if (d < 16) c[d] = 0 | t[n + d];
                    else {
                      var p = c[d - 15],
                        g = ((p << 25) | (p >>> 7)) ^ ((p << 14) | (p >>> 18)) ^ (p >>> 3),
                        v = c[d - 2],
                        y = ((v << 15) | (v >>> 17)) ^ ((v << 13) | (v >>> 19)) ^ (v >>> 10);
                      c[d] = g + c[d - 7] + y + c[d - 16];
                    }
                    var _ = (a & f) ^ (~a & h),
                      w = (r & i) ^ (r & o) ^ (i & o),
                      x =
                        ((r << 30) | (r >>> 2)) ^
                        ((r << 19) | (r >>> 13)) ^
                        ((r << 10) | (r >>> 22)),
                      S =
                        ((a << 26) | (a >>> 6)) ^
                        ((a << 21) | (a >>> 11)) ^
                        ((a << 7) | (a >>> 25)),
                      m = l + S + _ + u[d] + c[d],
                      B = x + w;
                    (l = h),
                      (h = f),
                      (f = a),
                      (a = (s + m) | 0),
                      (s = o),
                      (o = i),
                      (i = r),
                      (r = (m + B) | 0);
                  }
                  (e[0] = (e[0] + r) | 0),
                    (e[1] = (e[1] + i) | 0),
                    (e[2] = (e[2] + o) | 0),
                    (e[3] = (e[3] + s) | 0),
                    (e[4] = (e[4] + a) | 0),
                    (e[5] = (e[5] + f) | 0),
                    (e[6] = (e[6] + h) | 0),
                    (e[7] = (e[7] + l) | 0);
                },
                _doFinalize: function () {
                  var t = this._data,
                    e = t.words,
                    r = 8 * this._nDataBytes,
                    i = 8 * t.sigBytes;
                  return (
                    (e[i >>> 5] |= 128 << (24 - (i % 32))),
                    (e[14 + (((i + 64) >>> 9) << 4)] = n.floor(r / 4294967296)),
                    (e[15 + (((i + 64) >>> 9) << 4)] = r),
                    (t.sigBytes = 4 * e.length),
                    this._process(),
                    this._hash
                  );
                },
                clone: function () {
                  var t = o.clone.call(this);
                  return (t._hash = this._hash.clone()), t;
                },
              }));
            (e.SHA256 = o._createHelper(f)), (e.HmacSHA256 = o._createHmacHelper(f));
          })(Math),
          t.SHA256
        );
      });
    },
    function (t, n, e) {
      !(function (r, i) {
        t.exports = n = i(e(0));
      })(0, function (t) {
        return (
          (function (n) {
            function e(t, n, e, r, i, o, s) {
              var a = t + ((n & e) | (~n & r)) + i + s;
              return ((a << o) | (a >>> (32 - o))) + n;
            }

            function r(t, n, e, r, i, o, s) {
              var a = t + ((n & r) | (e & ~r)) + i + s;
              return ((a << o) | (a >>> (32 - o))) + n;
            }

            function i(t, n, e, r, i, o, s) {
              var a = t + (n ^ e ^ r) + i + s;
              return ((a << o) | (a >>> (32 - o))) + n;
            }

            function o(t, n, e, r, i, o, s) {
              var a = t + (e ^ (n | ~r)) + i + s;
              return ((a << o) | (a >>> (32 - o))) + n;
            }
            var s = t,
              a = s.lib,
              u = a.WordArray,
              c = a.Hasher,
              f = s.algo,
              h = [];
            !(function () {
              for (var t = 0; t < 64; t++) h[t] = (4294967296 * n.abs(n.sin(t + 1))) | 0;
            })();
            var l = (f.MD5 = c.extend({
              _doReset: function () {
                this._hash = new u.init([1732584193, 4023233417, 2562383102, 271733878]);
              },
              _doProcessBlock: function (t, n) {
                for (var s = 0; s < 16; s++) {
                  var a = n + s,
                    u = t[a];
                  t[a] =
                    (16711935 & ((u << 8) | (u >>> 24))) | (4278255360 & ((u << 24) | (u >>> 8)));
                }
                var c = this._hash.words,
                  f = t[n + 0],
                  l = t[n + 1],
                  d = t[n + 2],
                  p = t[n + 3],
                  g = t[n + 4],
                  v = t[n + 5],
                  y = t[n + 6],
                  _ = t[n + 7],
                  w = t[n + 8],
                  x = t[n + 9],
                  S = t[n + 10],
                  m = t[n + 11],
                  B = t[n + 12],
                  H = t[n + 13],
                  b = t[n + 14],
                  M = t[n + 15],
                  D = c[0],
                  j = c[1],
                  z = c[2],
                  A = c[3];
                (D = e(D, j, z, A, f, 7, h[0])),
                  (A = e(A, D, j, z, l, 12, h[1])),
                  (z = e(z, A, D, j, d, 17, h[2])),
                  (j = e(j, z, A, D, p, 22, h[3])),
                  (D = e(D, j, z, A, g, 7, h[4])),
                  (A = e(A, D, j, z, v, 12, h[5])),
                  (z = e(z, A, D, j, y, 17, h[6])),
                  (j = e(j, z, A, D, _, 22, h[7])),
                  (D = e(D, j, z, A, w, 7, h[8])),
                  (A = e(A, D, j, z, x, 12, h[9])),
                  (z = e(z, A, D, j, S, 17, h[10])),
                  (j = e(j, z, A, D, m, 22, h[11])),
                  (D = e(D, j, z, A, B, 7, h[12])),
                  (A = e(A, D, j, z, H, 12, h[13])),
                  (z = e(z, A, D, j, b, 17, h[14])),
                  (j = e(j, z, A, D, M, 22, h[15])),
                  (D = r(D, j, z, A, l, 5, h[16])),
                  (A = r(A, D, j, z, y, 9, h[17])),
                  (z = r(z, A, D, j, m, 14, h[18])),
                  (j = r(j, z, A, D, f, 20, h[19])),
                  (D = r(D, j, z, A, v, 5, h[20])),
                  (A = r(A, D, j, z, S, 9, h[21])),
                  (z = r(z, A, D, j, M, 14, h[22])),
                  (j = r(j, z, A, D, g, 20, h[23])),
                  (D = r(D, j, z, A, x, 5, h[24])),
                  (A = r(A, D, j, z, b, 9, h[25])),
                  (z = r(z, A, D, j, p, 14, h[26])),
                  (j = r(j, z, A, D, w, 20, h[27])),
                  (D = r(D, j, z, A, H, 5, h[28])),
                  (A = r(A, D, j, z, d, 9, h[29])),
                  (z = r(z, A, D, j, _, 14, h[30])),
                  (j = r(j, z, A, D, B, 20, h[31])),
                  (D = i(D, j, z, A, v, 4, h[32])),
                  (A = i(A, D, j, z, w, 11, h[33])),
                  (z = i(z, A, D, j, m, 16, h[34])),
                  (j = i(j, z, A, D, b, 23, h[35])),
                  (D = i(D, j, z, A, l, 4, h[36])),
                  (A = i(A, D, j, z, g, 11, h[37])),
                  (z = i(z, A, D, j, _, 16, h[38])),
                  (j = i(j, z, A, D, S, 23, h[39])),
                  (D = i(D, j, z, A, H, 4, h[40])),
                  (A = i(A, D, j, z, f, 11, h[41])),
                  (z = i(z, A, D, j, p, 16, h[42])),
                  (j = i(j, z, A, D, y, 23, h[43])),
                  (D = i(D, j, z, A, x, 4, h[44])),
                  (A = i(A, D, j, z, B, 11, h[45])),
                  (z = i(z, A, D, j, M, 16, h[46])),
                  (j = i(j, z, A, D, d, 23, h[47])),
                  (D = o(D, j, z, A, f, 6, h[48])),
                  (A = o(A, D, j, z, _, 10, h[49])),
                  (z = o(z, A, D, j, b, 15, h[50])),
                  (j = o(j, z, A, D, v, 21, h[51])),
                  (D = o(D, j, z, A, B, 6, h[52])),
                  (A = o(A, D, j, z, p, 10, h[53])),
                  (z = o(z, A, D, j, S, 15, h[54])),
                  (j = o(j, z, A, D, l, 21, h[55])),
                  (D = o(D, j, z, A, w, 6, h[56])),
                  (A = o(A, D, j, z, M, 10, h[57])),
                  (z = o(z, A, D, j, y, 15, h[58])),
                  (j = o(j, z, A, D, H, 21, h[59])),
                  (D = o(D, j, z, A, g, 6, h[60])),
                  (A = o(A, D, j, z, m, 10, h[61])),
                  (z = o(z, A, D, j, d, 15, h[62])),
                  (j = o(j, z, A, D, x, 21, h[63])),
                  (c[0] = (c[0] + D) | 0),
                  (c[1] = (c[1] + j) | 0),
                  (c[2] = (c[2] + z) | 0),
                  (c[3] = (c[3] + A) | 0);
              },
              _doFinalize: function () {
                var t = this._data,
                  e = t.words,
                  r = 8 * this._nDataBytes,
                  i = 8 * t.sigBytes;
                e[i >>> 5] |= 128 << (24 - (i % 32));
                var o = n.floor(r / 4294967296),
                  s = r;
                (e[15 + (((i + 64) >>> 9) << 4)] =
                  (16711935 & ((o << 8) | (o >>> 24))) | (4278255360 & ((o << 24) | (o >>> 8)))),
                  (e[14 + (((i + 64) >>> 9) << 4)] =
                    (16711935 & ((s << 8) | (s >>> 24))) | (4278255360 & ((s << 24) | (s >>> 8)))),
                  (t.sigBytes = 4 * (e.length + 1)),
                  this._process();
                for (var a = this._hash, u = a.words, c = 0; c < 4; c++) {
                  var f = u[c];
                  u[c] =
                    (16711935 & ((f << 8) | (f >>> 24))) | (4278255360 & ((f << 24) | (f >>> 8)));
                }
                return a;
              },
              clone: function () {
                var t = c.clone.call(this);
                return (t._hash = this._hash.clone()), t;
              },
            }));
            (s.MD5 = c._createHelper(l)), (s.HmacMD5 = c._createHmacHelper(l));
          })(Math),
          t.MD5
        );
      });
    },
  ]);
});
